<!-- APP-APP管理 -->
<template>
  <!-- z-index: 100; -->
  <div class="md-layout" style="position:relative;">
    <!-- 主菜单表格 ../App/AppMainTable.vue -->
    <app-main-table v-show="!this.selectedAppDetail.id" :comps="compData" @select="table_selectMainMenu"/>

    <!-- 详情 -->
    <div v-if="hasDetail" class="md-detials md-layout-item md-size-100">
      <md-card>
        <!-- 卡片头 -->
        <md-card-header class=" md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>{{icon}}</md-icon>
          </div>
          <!-- 标题 + 返回按钮 -->
          <h4 class="title">
            {{selectedAppDetail.name}}
            <md-button @click="cleanedSelect" class="md-primary md-sm md-info right-button md-just-icon md-round">
              <md-icon>reply</md-icon>
            </md-button>
          </h4>
          <!-- 详情信息 + 修改按钮 + 类型选择 -->
          <div class="md-subhead">
            <!-- APP ID -->
            APP ID : {{selectedAppDetail.app_id}} <br/>
            <!-- 包名 -->
            {{$I18n("app_packet")}} : {{selectedAppDetail.app_packet}}
            <!-- 状态 -->
            {{$I18n("state")}} : {{selectedAppDetail.state === 1 ?$I18n("open") :$I18n("close")}}
            <!-- 修改按钮 -->
            <div class="edit-button" @click="$refs.modal.open()">
              {{$I18n('edit')}}
            </div>

            <div class="edit-button" @click="openResMng = true">
              {{$I18n("res_mng")}}
            </div>
            <!-- APP - 类型选择 -->
            <div style="position: absolute;top: 10px;right: 100px;">
              <md-field>
                <md-select v-model="change_sub_id">
                  <md-option v-for="item in appSubApp_option" :key="item.app_id" :value="item.app_id">{{item.client_name}}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
        </md-card-header>
        <md-card-content class="md-layout">
          <!-- 分割线 -->
          <div class="md-layout-item md-size-100 line"></div>
          <!-- 左侧菜单 -->
          <div :class="{'menu': hasDetail}" class="scroll md-layout-item md-size-20 md-small-size-30 md-xsmall-size-100" :style="{'border-right':'1px solid rgba(180, 180, 180, 0.3)','margin-top':'20px'}">
            <div class="main-box">
              <template v-for="(firItem, firIndex) in menusList">
                <div v-if="firIndex > 0" :key="firIndex" class="line"></div>
                <div v-for="secItem in firItem" :key="secItem" @click="() => {active = secItem}" :class="{'selected': active == secItem }" class="menu-item-box">
                  {{secItem}}
                </div>
              </template>
            </div>
          </div>
          <!-- 右侧主要内容 -->
          <div :key="selectedAppDetail.app_id" class="scroll md-layout-item md-size-80 md-small-size-70 md-xsmall-size-100" 
            :style="{'margin-top':'20px','max-height':'calc( 100vh - 192px - 64px - 51px );'}"
          >
            <!-- 支付配置 ../App/PayConfig.vue -->
            <pay-config v-if='active === $I18n("setting_payment")' :app_id="selectedAppDetail.app_id"/>
            <!-- 商品配置 ../App/ShopConfig.vue -->
            <shop-config v-show='active === $I18n("setting_product")' :app_id="selectedAppDetail.app_id" :comps="compData" :comp_id="selectedApp.comp_id"/>
            <!-- 云存储配置 ../App/CloudConfig.vue -->
            <!-- <cloud-config v-if='active === $I18n("setting_cloud")' :app_id="selectedAppDetail.app_id" /> -->
            <!-- 流量 ../App/FlowConfig.vue -->
            <flow-config v-if='active === $I18n("setting_flow")' :app_id="selectedAppDetail.app_id" />
            <!-- 版本 ../App/VersionManage.vue -->
            <version-manage v-if='active === $I18n("app_version")' :app_id="selectedAppDetail.app_id" />
            <!-- 二维码 ../App/QrCode.vue -->
            <qr-code v-if='active === $I18n("qrcode")' :app_id="selectedAppDetail.app_id" />
            <!-- 绑定设置 ../App/BindSet.vue -->
            <bind-setting v-if='active === $I18n("bind_setting")' :app_id="selectedAppDetail.app_rela_id" />
            <!-- 广告配置 ../App/AdUnit.vue -->
            <ad-unit v-if='active === $I18n("ad_unit")' :app_id="selectedAppDetail.app_id"/>
            <!-- 邮件配置 ../App/EmailSetting.vue -->
            <email-setting v-if='active === $I18n("setting_email_bind")' :app_id="selectedAppDetail.app_id"/>
            <!-- SMS配置 ../App/SmsSetting.vue -->
            <sms-setting v-if='active === $I18n("setting_sms_bind")' :app_id="selectedAppDetail.app_id"/>
            <!-- 语音配置 ../App/VoiceSetting.vue -->
            <voice-setting v-if='active === $I18n("setting_voice_bind")' :app_id="selectedAppDetail.app_id"/>
            <!-- 消息平台配置 ../App/MsgPlatSetting.vue -->
            <msg-plat-setting v-if='active === $I18n("msg_plat_conf")' :app_id="selectedAppDetail.app_id" :client="selectedAppDetail.client_type"/>
            <!-- 用户统计 ../App/UserStatistics.vue -->
            <user-statistics v-if='active === $I18n("user_statis")' :app_id="selectedApp.id"/>
            <!-- 问题反馈 ../App/ProblemFreeback.vue -->
            <problem-feedback v-if='active === $I18n("problem_feedback")' :app_id="selectedAppDetail.app_id"/>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 (修改APP) -->
    <simple-modal 
      ref    = "modal"
      :title = "$I18n('edit_app')"
      :right = "true"
      @submit= "modal_openModal"
    >
      <template slot="body">
        <div>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modal_data.Form[item.keys]" 
            :error="modal_data.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
    <res-mng v-if="openResMng" @close="openResMng = false" :app_id="selectedApp.id"/>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";

import AppMainTable from "./App/AppMainTable.vue"
import PayConfig from "./App/PayConfig.vue";
import ShopConfig from "./App/ShopConfig.vue";
import FlowConfig from "./App/FlowConfig.vue";
import VersionManage from "./App/VersionManage.vue";
import QrCode from "./App/QrCode.vue";
import BindSetting from "./App/BindSetting.vue";
import EmailSetting from "./App/EmailSetting.vue";
import SmsSetting from "./App/SmsSetting.vue";
import VoiceSetting from "./App/VoiceSetting.vue";
import UserStatistics from "./App/UserStatistics.vue";
import ProblemFeedback from "./App/ProblemFeedback.vue";
import MsgPlatSetting from "./App/MsgPlatSetting.vue";
import ResMng from "./AppResMng/ResMng.vue";
import AdUnit from "./App/AdUnit.vue";

// import ResMng from "./App/ResMng.vue";

export default {
  components: {
    MsgPlatSetting, AppMainTable,   PayConfig,ShopConfig,   
    FlowConfig,     VersionManage,  QrCode,BindSetting ,  EmailSetting, SmsSetting, VoiceSetting,
    UserStatistics, ProblemFeedback,ResMng, AdUnit, 
  },
  data() {
    return {
      icon  : "apps",
      
      menusList : [
        [
          this.$I18n("setting_payment"), 
          this.$I18n("setting_product"), 
          // this.$I18n("setting_cloud"), 
          this.$I18n("setting_flow"), 
          this.$I18n("app_version"), 
          // this.$I18n("qrcode"),
          this.$I18n("bind_setting"),
          this.$I18n("ad_unit"),
        ],[
          this.$I18n("setting_email_bind"), 
          this.$I18n("setting_sms_bind"),
          this.$I18n("setting_voice_bind"),
        ],
        [this.$I18n("msg_plat_conf")],
        [ 
          this.$I18n("user_statis"),
        ],
        // [this.$I18n("problem_feedback")],
      ],
      openResMng    : false, // 是否展示 res 管理面板
      compData      : [],    // 公司列表
      modal         : false, // 弹窗打开
      active        : "",    // 正在打开的子菜单

      change_sub_id : "",    // 选择中的APP sub ID
      appSubApp     : [],    // APP的sub数组
      selectedApp   : {},    // 选择中的APP Object
      selectedAppDetail : {},// 选择中的APP sub Object
      modal_data: new FormClass({ // 弹窗-弹窗表单数据
        id : "",
        app_id      : {
          init : "",
        },
        app_packet  : {
          init : "",
          check: "required",
        },
        client_type : 3,
        state       : 1,
      }),
    };
  },
  computed: {
    // 弹窗表单
    form_modalData(){ 
      return [
        {
          label   : this.$I18n("app_id"),
          keys    : "app_id",
          type    : "input",
          placeholder: this.$I18n('deivce_code_placehoder'),
          disabled:  this.modal_data.Form.id != "",
        },{
          label   : this.$I18n("client_type"),
          keys    : "client_type",
          type    : "select",
          required: true,
          disabled: this.modal_data.Form.id != "",
          options : [
            {id : 3, name : this.$I18n("android")},
            {id : 2, name : this.$I18n("ios")},
            {id : 6, name : this.$I18n("web")},
            {id : 1, name : this.$I18n("pc")},
          ],
        },{
          label   : this.$I18n("app_packet"),
          keys    : "app_packet",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          required: true,
          options : [
            {id : 1, name : this.$I18n("open")},
            {id : 2, name : this.$I18n("close")},
          ],
          hide    : this.UserInfo.role_id >= 10000,
        }
      ]
    },
    // APP 类型
    appSubApp_option(){ 
      return this.appSubApp.map(item => {
        let client_name = "";
        switch(item.client_type){
          case 6:
            client_name = this.$I18n("web")
            break
          case 3:
            client_name = this.$I18n("android")
            break
          case 2:
            client_name = this.$I18n("ios")
            break
          case 4:
            client_name = this.$I18n("mac")
            break
          case 5:
            client_name = this.$I18n("ipad")
            break
          case 1:
            client_name = this.$I18n("pc")
            break
          case 0:
          default:
            client_name = this.$I18n("unknow")
            break
        }
        let state_name = this.$I18n("close");
        if(item.state === 1){
          state_name = this.$I18n("open");
        }
        return {
          ...item,
          state_name,
          client_name,
        }
      });
    },
    // 是否显示详情
    hasDetail(){
      return !!this.selectedAppDetail.id && this.openResMng == false;
    },
  },
  watch: {
    change_sub_id(to){
      let newSub = this.appSubApp.filter(i => {
        return i.app_id === to;
      })[0];
      if(!newSub){
        return
      }
      if(this.selectedAppDetail.app_id !== newSub.app_id){
        this.selectedAppDetail = {...newSub};
        this.modal_data.Update(newSub);
      }
    },
    // 打开详情的时候初始化
    hasDetail (to){
      if(to) {
        this.active = this.$I18n('setting_payment')
      }
    },
  },
  mounted : function() {
    this.api_getCompData();
  },
  methods: {
    cleanedSelect(){ // 返回APP列表
      this.selectedAppDetail = {};
      this.selectedApp = {};
      this.change_sub_id = "";
      this.appSubApp = [];
    },
    modal_openModal (){ // 弹窗-打开弹窗
      // 校验参数
      if(this.modal_data.Check()){
        this.$errorMsg(this.$I18n("pls_input") + this.$I18n("app_packet"))
        return
      }
      let sendData = {
        ...this.modal_data.Form,
        rela_id  : this.selectedApp.id,
      }
      this.$api.editAppDetail(sendData) // api: /user/app/detail/set
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.$refs.modal.close();
          this.api_getAppDetail();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 选择主菜单
    table_selectMainMenu(item){
      if(this.selectedApp.id == item.id){
        this.selectedApp = {};
      } else {
        this.selectedApp = item;
        this.api_getAppDetail();
      }
    },
    api_getCompData(){ // 获取
      return this.$api.getCompanyList({})
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.compData = [];
        }))
    },
    api_getAppDetail(){ // API-获取APP的详细数据
      return this.$api.queryAppDetail({ // api: /user/app/detail/query
        id : this.selectedApp.id,
      })
        .then(this.$Then(res => {
          this.appSubApp = res.data;
          if(this.appSubApp.length > 0 && this.appSubApp.every(i => i.app_id !== this.change_sub_id)){
            let newArray = this.appSubApp.sort(a => {
              if(a.client_type === 3){
                return -1
              }
            })
            this.change_sub_id = newArray[0].app_id;
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.appSubApp = [];
        }))
    },
  },
}
</script>
<style lang="css" scoped>
  .md-detials /deep/ .md-card{
    z-index: 2 !important;
  }
</style>
<style lang="scss" scoped>
  .edit-button{
    font-size: 14px;
    display: inline-block; 
    font-weight: 600; 
    margin-left: 15px; 
    color: #00bcd4; 
    cursor: pointer; 
    border-radius: 5px;
  }
  .line{
    content: "";
    height: 1px;
    width: calc(100% - 15px);
    background-color: rgba(180, 180, 180, 0.3);
  }
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    // width: calc( 100% - 15px );
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }
  .main-box{
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 0;
    // box-shadow: 0px 0 10px #a9a9a9;
    // padding-left: 20px;
    margin-right: 10px;
    box-sizing:border-box;
  }
  .scroll{
    max-height: calc( 100vh - 192px - 64px - 51px );
    overflow-y: auto;
    overflow-x: hidden;
    // padding-right: 0;
    transition: all 0s !important;
  }
  .scroll::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 8px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .scroll::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 8px;
    // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
    background : transparent;
  }
  .scroll::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background : transparent;
  }
  .scroll:hover::-webkit-scrollbar-thumb {
    background   : #00bcd4;
  }
  .scroll:hover::-webkit-scrollbar-track {
    background   : rgb(0 188 212 / 5%);
  }

  .name {
      font-size: 16px;
      line-height: 24px;
  }
  .message {
      width: calc(100% - 44px);
      border: 2px solid #ccc;
      padding: 6px;
      color: #000000;
      border-radius: 8px;
      margin-top: 4px;
      line-height: 20px;
      font-size: 14px;
      word-wrap:break-word;
      text-align: left;
      float: left;
  }
  .md-layout {
    overflow: hidden;
  }
  @media screen and (max-width: 600px){
    .scroll.menu{
      margin-top : 0 !important;
      border-right: 0 !important;
      max-height: none;
      padding: 0;
      overflow-y: auto;
      overflow-x: auto;
      border-bottom: 1px solid rgba(180, 180, 180, 0.3);
    }
    .scroll{
      max-height: none;
    }
    .line{
      display: none;
    }
    .main-box {
      margin: 0;
      display:flex;
    }
    .main-box .menu-item-box{
      width: auto;
      display: inline-block;
      white-space: nowrap;
    }
  }
</style>